import { useState } from 'react'
import { api, ApiError } from '../lib/api'
import { useAuth } from '../lib/auth'
import { Field, Modal } from './ui'

const MIN_LENGTH = 12

export default function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const { refresh } = useAuth()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const mismatch = confirm.length > 0 && next !== confirm
  const tooShort = next.length > 0 && next.length < MIN_LENGTH
  const canSubmit = current && next.length >= MIN_LENGTH && next === confirm && !busy

  async function submit() {
    setBusy(true)
    setError(null)
    try {
      await api.post('/api/admin/auth/change-password', { currentPassword: current, newPassword: next })
      await refresh()
      onClose()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not change the password.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal
      title="Change password"
      onClose={onClose}
      footer={
        <>
          <button className="btn ghost" onClick={onClose}>
            Cancel
          </button>
          <button className="btn primary" onClick={submit} disabled={!canSubmit}>
            {busy ? 'Saving…' : 'Change password'}
          </button>
        </>
      }
    >
      {error && <div className="banner danger">{error}</div>}

      <Field label="Current password">
        <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" />
      </Field>

      <Field label="New password" hint={`At least ${MIN_LENGTH} characters.`}>
        <input type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" />
      </Field>
      {tooShort && <div className="field-hint" style={{ color: 'rgb(var(--warn))' }}>Too short.</div>}

      <Field label="Confirm new password">
        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
      </Field>
      {mismatch && <div className="field-hint" style={{ color: 'rgb(var(--danger))' }}>The two passwords do not match.</div>}
    </Modal>
  )
}
